import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {supportingDocumentsSelect} from "../../redux/selector/supportingDocumentsSelector"
import {
    Header, 
    Paragraph, 
    Button,
    LineSeperator,
    NavigationLinkButton,
    ErrorMark,
    ErrorWithString
} from '../../components/RegularComponents'
import TopNavigationBar from "../TopNavigationBar"
import { useCallback, useEffect, useState } from 'react';
import {
    VIEW_MODE_REGULAR,
    // APPLICATION_MODE_RENEW,
    VIEW_MODE_RENEWAL_PREVIEW,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    APPLICATION_TYPE_COLLECTION_AGENCY,
    APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY,
    DOCUMENT_TYPE_NOTICES_LETTERS,
    DOCUMENT_TYPE_FORMS_AGREEMENTS,
    DOCUMENT_CONTENT_TYPE_PDF,
    DOCUMENT_CONTENT_TYPE_DOC,
    DOCUMENT_CONTENT_TYPE_DOCX,
    DOCUMENT_CONTENT_TYPE_XLS,
    DOCUMENT_CONTENT_TYPE_XLSX,
    REQUEST_STATUS,
    APPLICATION_MODE_RENEW,
} from '../../app/constants'
import { 
    replaceUrlParams
} from '../../app/utils';
import Navigation from '../Navigation';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import DocumentViewer from '../../components/DocumentViewer/DocumentViewer'
import { DocumentViewerFileNameLink, DownloadFileNameLink } from '../../components/DocumentViewer/DocumentFileComponent';
import { ERROR_STRING, VALIDATION_ERROR } from '../../app/errors';
import {totalFileSizeAllowedInMB, individualFileSizeAllowedInMB} from "../../app/constants"
import { fetchDocumentData } from '../../redux/slice/supportingDocumentsSlice';
import "./SupportingDocuments.styles.scss"
import { setAgencySupportingDocuments } from '../../redux/slice/primaryAgencyApplicationSlice';
import { 
    acceptedFileFormats, 
    convertFileDataForUrl, 
    extractBase64, 
    fileNameWithLengthLimit, 
    fileTypeEnum, 
    validateFileName
} from '../../app/documentUploadUtils';

const docTypes = [
    DOCUMENT_CONTENT_TYPE_PDF, 
    DOCUMENT_CONTENT_TYPE_DOC, 
    DOCUMENT_CONTENT_TYPE_DOCX, 
    DOCUMENT_CONTENT_TYPE_XLS,
    DOCUMENT_CONTENT_TYPE_XLSX
]

const SupportingDocuments = (props) => {
    const {supportingDocuments, dispatch} = props
    const{applicationType, applicationMode} = props.match.params

    const [formsFiles, setFormsFiles] = useState(supportingDocuments.formsAgreements)
    const [noticesFiles, setNoticesFiles] = useState(supportingDocuments.noticesLetters)
    const [suretyBondDocs/*, setSuretyBondDocs*/] = useState(supportingDocuments.suretyBondDocs)

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false)
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null)
    const [selectedFile,setSelectedFile] = useState(null)

    const [showValidationError, setShowValidationError] = useState(false)

    const [formsValidationError, setFormsValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [noticesValidationError, setNoticesValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [totalFileSizeError, setTotalFileSizeError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    // const [viewMode,setViewMode] = useState(props.viewMode ? 
    //     props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? 
    //         VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

    //  year 1 we will need to show them the same screen for attachments that new applicants see.
    // (no previous documents)  
    const [viewMode, setViewMode] = useState(props.viewMode 
                            ?  props.viewMode  : VIEW_MODE_REGULAR)

    const validateFormsCB = useCallback(() => {
        const formsToSave = formsFiles.filter(file => file.changeType !== "DELETE")

        if(!formsToSave.length) {
            setFormsValidationError(VALIDATION_ERROR.EMPTY)
            return false
        }
        
        for(let i = 0; i < formsToSave.length; i++) { 
            const {filename, documentContentType} = formsToSave[i]
            if(!filename) { 
                setFormsValidationError(VALIDATION_ERROR.EMPTY)
                return false
            }

            if(!docTypes.find(d => d === documentContentType)) { 
                setFormsValidationError(VALIDATION_ERROR.FILE_TYPE_INVALID)
                return false
            }
        }

        setFormsValidationError(VALIDATION_ERROR.NO_ERROR)
        return true
    }, [formsFiles, setFormsValidationError])

    const validateNoticesCB = useCallback(() => {
        const noticesToSave = noticesFiles.filter(file => file.changeType !== "DELETE")

        if(!noticesToSave.length) {
            setNoticesValidationError(VALIDATION_ERROR.EMPTY)
            return false
        }

        for(let i = 0; i < noticesToSave.length; i++) { 
            const {filename, documentContentType} = noticesToSave[i]

            if(!filename) { 
                setNoticesValidationError(VALIDATION_ERROR.EMPTY)
                return false
            }

            if(!docTypes.find(d => d === documentContentType)) { 
                setNoticesValidationError(VALIDATION_ERROR.FILE_TYPE_INVALID)
                return false
            }
        }

        setNoticesValidationError(VALIDATION_ERROR.NO_ERROR)
        return true
    }, [noticesFiles,setNoticesValidationError])

    const validateTotalFileSize = () => { 
        let totalFileSize = 0

        const accumulateFileSize = file => { 
            if(file.changeType === "SAVE")
                totalFileSize += parseInt(file.fileSize)
        }

        formsFiles.forEach(accumulateFileSize)
        noticesFiles.forEach(accumulateFileSize)

        if((totalFileSize/(2 ** 20)) > 50) { 
            setShowValidationError(true)
            setTotalFileSizeError(VALIDATION_ERROR.SUPPORTING_DOC_VERY_LARGE_FILE)
            return false
        }

        return true
    }

    const validateData = () => { 
        const ret1 = validateFormsCB()
        const ret2 = validateNoticesCB() 
        const ret3 = validateTotalFileSize()
        return ( ret1 && ret2 && ret3)
    }

    const isFomrsValid = () => { 
        if(showValidationError) { 
            return (formsValidationError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isNoticesValid = () => { 
        if(showValidationError) { 
            return (noticesValidationError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isTotalFileSizeValid = () => { 
        if(showValidationError) { 
            return (totalFileSizeError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const onNextClick = () => {
        
        setApplicationSaveError(false)

        if(props.supportingDocuments.applicationSavingRequestStatus === REQUEST_STATUS.IN_PROGRESS) { 
            // a save request is already outstanding...
            return
        } 

        if(!validateData()) { 
            setShowValidationError(true)
            return 
        }

        setShowValidationError(false)

        // save and push to next
        const removeFileSizeMapCallback = f => {
            if(f.fileSize)
                delete f.fileSize
            return f
        }

        dispatch(setAgencySupportingDocuments(
                [...formsFiles.map(removeFileSizeMapCallback), 
                ...noticesFiles.map(removeFileSizeMapCallback), 
                ...suretyBondDocs.map(removeFileSizeMapCallback)]
        ))

        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                let nextUrl = supportingDocuments.navigation.next

                if(applicationMode === APPLICATION_MODE_RENEW && supportingDocuments.navigation.nextRenewal) {
                    nextUrl = supportingDocuments.navigation.nextRenewal
                }
                else if((viewMode === VIEW_MODE_RENEWAL_PREVIEW || viewMode === VIEW_MODE_RENEWAL_EDIT)
                    && supportingDocuments.navigation.nextRenewal) {
                    nextUrl = supportingDocuments.navigation.nextRenewal
                }
                dispatch(push(replaceUrlParams(nextUrl,applicationType, applicationMode)))
            })
            .catch(err => {
                setApplicationSaveError(true)
            })
    }

    const fileSizeReplacement = (string, fileSize) => { 
        const replaceRegExp = /<file_size>/g 
        const errorString = string.replace(replaceRegExp,(fileSize + "MB"))
        return errorString
    }

    const onFormsFileInputChange = (e) => {
        if(e.target.files.length > 0) {
            let file = e.target.files[0]

            // individual file size can not be more than 15 MB
            if(file.size > (individualFileSizeAllowedInMB * (2 ** 20))) {
                alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE, individualFileSizeAllowedInMB))
                return
            } else if(!validateFileName(file.name)) {
                alert("File name is not valid. Please select another file.")
                return
            }

            let reader = new FileReader()
            reader.onload = (readerData) => {
                setFormsFiles([...formsFiles, {
                    filename : fileNameWithLengthLimit(file.name), 
                    documentContentType : fileTypeEnum(file.type),
                    data : extractBase64(readerData.target.result),
                    changeType : "SAVE",
                    documentType: "FORMS_AGREEMENT",
                    fileSize : file.size
                }])
            }
            reader.readAsDataURL(file)
        }
    }

    const onNoticesFileInputChange = (e) => {
        if(e.target.files.length > 0) {
            let file = e.target.files[0]

            // individual file size can not be more than 15 MB
            if(file.size > (individualFileSizeAllowedInMB * (2 ** 20))) { 
                alert(fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_INDIVIDUAL_FILE,individualFileSizeAllowedInMB))
                return
            } else if(!validateFileName(file.name)) {
                alert("File name is not valid. Please select another file.")
                return
            }
            
            let reader = new FileReader()
            reader.onload = (readerData) => {
                setNoticesFiles([...noticesFiles, {
                    filename : fileNameWithLengthLimit(file.name), 
                    documentContentType : fileTypeEnum(file.type),
                    data : extractBase64(readerData.target.result),
                    changeType : "SAVE",
                    documentType: "NOTICES_LETTERS",
                    fileSize : file.size
                }])
            }
            reader.readAsDataURL(file)
        }
    }

    const fileComponent = (id, file, index) => {

        return (
            <>
                <div className="col-8 supportingDocumentsFileContentWrapper">
                    <span className="fileName">
                        {file.documentContentType === DOCUMENT_CONTENT_TYPE_PDF ? 
                            <DocumentViewerFileNameLink
                                id={"supporting-document-view-file-" + file.filename}
                                key={"supporting-document-view-file-" + file.filename}
                                file={file}
                                onClick={() => { 
                                    if(file.data) { 
                                        let fileDataUrl = convertFileDataForUrl(file.data, file.documentContentType)
                                        setDocumentViewerDocument(fileDataUrl)
                                        setOpenDocumentViewer(true)
                                        setSelectedFile(file)
                                    } else { 
                                        // download data and then view it.
                                        if(file.guid) { 
                                            dispatch(fetchDocumentData(file.guid))
                                                .then(downloadFile => {
                                                    if(downloadFile) { 
                                                        let fileDataUrl = convertFileDataForUrl(downloadFile.data, downloadFile.documentContentType)
                                                        setDocumentViewerDocument(fileDataUrl)
                                                        setOpenDocumentViewer(true)
                                                        setSelectedFile(downloadFile)
                                                    }
                                                })
                                                .catch((error) => {
                                                    console.error(error)
                                                })
                                        }
                                        
                                    }
                                }}
                            /> : 
                            <DownloadFileNameLink
                                id={"supporting-document-download-file-" + file.filename}
                                componentKey={"supporting-document-download-file-" + file.filename}
                                file={file} 
                            />
                        }
                    </span>
                    
                    {(viewMode !== VIEW_MODE_RENEWAL_PREVIEW 
                        && applicationMode !== APPLICATION_MODE_RENEW) && 
                        <NavigationLinkButton
                            id={id + "-remove-link"}
                            text={"- Remove this file"}
                            onClick={() => {

                                if(id === 'form-files-components') {
                                    let updatedFiles = [...formsFiles] 

                                    let file = updatedFiles[index]

                                    if(file.guid) { 
                                        updatedFiles.splice(index, 1, Object.assign({}, file, {changeType: "DELETE"}))
                                    } else { 
                                        updatedFiles.splice(index, 1)
                                    }
                                    
                                    setFormsFiles(updatedFiles)   
                                } else { 
                                    let updatedFiles = [...noticesFiles]
                                    let file = updatedFiles[index]

                                    if(file.guid) {
                                        updatedFiles.splice(index, 1, Object.assign({}, file, {changeType: "DELETE"})) 
                                    } else { 
                                        updatedFiles.splice(index, 1)
                                    }
                                    setNoticesFiles(updatedFiles)
                                }
                            }}
                        />
                    }
                </div>

                <DocumentViewer 
                    fileData={documentViewerDocument}
                    isOpen={openDocumentViewer}
                    fileName={selectedFile?.filename}
                    handleClose={() => setOpenDocumentViewer(false)}
                />
            </>
        )
    }

    const formsFilesComponents = () => {
        let components = []
        formsFiles.forEach(( file, index) => {
            if(file.changeType !== "DELETE") { 
                components.push(fileComponent("form-files-components",file, index))
            }
        })

        return components
    }

    const noticesFilesComponents = () => {
        let components = []
        noticesFiles.forEach((file, index) => {
            if(file.changeType !== "DELETE") {
                components.push(fileComponent("notices-files-components",file, index))
            }
        })

        return components
    }

    useEffect(() => {
        setFormsFiles(supportingDocuments.formsAgreements)
        setNoticesFiles(supportingDocuments.noticesLetters)
    }, [
        supportingDocuments.formsAgreements,
        supportingDocuments.noticesLetters,
        setFormsFiles,
        setNoticesFiles
    ])

    useEffect(() => {
        validateFormsCB()
    }, [
        formsFiles,
        validateFormsCB
    ])

    useEffect(() => {
        validateNoticesCB()
    }, [
        noticesFiles, 
        validateNoticesCB
    ])

    const documentHelpTextComponent = () => {
        return (<div className="help-block topMarginNormal">
            The maximum file size allowed is 15MB per file and 50MB total.
            Supporting document types are Microsoft Office Word, Microsoft Office Excel or Adobe PDF.
            All digital files must be in an uncompressed format, i.e. no Zip or ARC files
        </div>)
    }

    const generalError = () => { 
        return (!isTotalFileSizeValid() || applicationSaveError)
    }

    const generalErrorString = () => {
        if(!isTotalFileSizeValid())
            return (fileSizeReplacement(ERROR_STRING.SUPPORTING_DOC_VERY_LARGE_TOTAL_FILE, totalFileSizeAllowedInMB))
        else if(applicationSaveError) 
            return ERROR_STRING.APPLICATION_SAVE_ERROR

        return ""
    }

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <>
                <TopNavigationBar {...props} />
                <div className="row">
                    <div className="col-11">
                        <Header 
                            id="supporting-doc-header" 
                            header={viewMode === VIEW_MODE_RENEWAL_PREVIEW ?
                                supportingDocuments.headerRenewal : supportingDocuments.header} />
                        <Paragraph 
                            id="supporting-doc-text"
                            text={viewMode === VIEW_MODE_RENEWAL_PREVIEW ?
                                supportingDocuments.textRenewal : supportingDocuments.text} />
                    </div>
                </div>
            </>
            }
            
            <div className="row">
            <div className="col-11">
                <h2>
                    Forms or agreements
                    {/* <span style={{marginLeft: "10px"}}><i className={"fa fa-question-circle-o"} /></span> */}
                </h2>
            </div>
            </div>
            <div className="row">
            <div className="col-11">
                {applicationType === APPLICATION_TYPE_COLLECTION_AGENCY && 
                <p>Upload one copy of each agreement your collection agency uses when entering into an agreement with a creditor.</p>}
                
                {applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY && 
                <p>Upload one copy of each agreement your debt management agency uses when entering into an agreement with a creditor.</p>}
            </div>
            </div>
            <div className="row bottomMarginMedium">
                {formsFilesComponents()}
            </div>
            <div className="row">
                <div className="col-lg-8">
                    {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
                    <fieldset className="ns-fieldset" id="supporting-documents-forms-form">
                        <div className={"ns-fieldset" + (!isFomrsValid() ? " ns-fieldset-message-error" : "")}>
                            <label 
                                className="ns-label"
                                id="supporting-document-forms-file-label"
                                htmlFor="supporting-document-forms-file-input">
                                    Upload a file
                            </label>
                            {!isFomrsValid() && 
                            <span id="supporting-document-forms-file-input-error" className="ns-error-message form-validation-error topMarginNormal">
                                {ErrorWithString(ERROR_STRING.SUPPORTING_DOC_MISSING_FORM)}
                            </span>}
                            <div className="ns-file-input">
                                <input 
                                    style={{width: "15em", display: "inline"}}
                                    type="file" 
                                    className={isFomrsValid() ? "ns-input" : "ns-input--error"}
                                    accept={acceptedFileFormats(DOCUMENT_TYPE_FORMS_AGREEMENTS).join(',')}
                                    value=""
                                    id="supporting-document-forms-file-input"
                                    name="supporting-document-forms-file-input"
                                    multiple={false}
                                    onChange={onFormsFileInputChange} />
                            </div>
                            
                        </div>
                        {documentHelpTextComponent()}
                    </fieldset>
                    }
                </div>
            </div>
            <LineSeperator />
            <div className="row">
            <div className="col-11">
                <h2>
                    Notices or letters to clients
                    {/* <span style={{marginLeft: "10px"}}><i className={"fa fa-question-circle-o"} /></span> */}
                </h2>
            </div>
            </div>
            <div className="row">
            <div className="col-11"> 
                {applicationType === APPLICATION_TYPE_COLLECTION_AGENCY && 
                <p>Upload one copy of each notice or letter your collection agency uses with your debtors.</p>}
                
                {applicationType === APPLICATION_TYPE_DEBT_MANAGEMENT_AGENCY && 
                <p>Upload one copy of each notice or letter your debt management agency uses with your clients.</p>}
            </div>
            </div>
            <div className="row bottomMarginNormal">
                {noticesFilesComponents()}
            </div>
            {viewMode !== VIEW_MODE_RENEWAL_PREVIEW &&
            <div className="row">
                <div className="col-lg-8">
                    <fieldset className="ns-fieldset">
                        <div className={"ns-fieldset"  + (!isNoticesValid() ? " ns-fieldset-message-error" : "")}>
                            <label 
                                id="supporting-document-notices-file-label"
                                className="ns-label"
                                htmlFor="supporting-document-notices-file-input">
                                    Upload a file
                            </label>
                            {!isNoticesValid() && <div className="ns-error-message form-validation-error topMarginNormal">
                                {ErrorWithString(ERROR_STRING.SUPPORTING_DOC_MISSING_NOTICE)}
                            </div>}
                            <div className="ns-file-input inlineDisplay">
                                <input 
                                    style={{width: "15em", display: "inline"}}
                                    type="file" 
                                    className="ns-input"
                                    id="supporting-document-notices-file-input"
                                    name="supporting-document-notices-file-input"
                                    accept={acceptedFileFormats(DOCUMENT_TYPE_NOTICES_LETTERS).join(',')}
                                    multiple={false} 
                                    value=""
                                    onInput={onNoticesFileInputChange} />
                            </div>
                        </div>
                        {documentHelpTextComponent()}
                    </fieldset>
                </div>
            </div>
            }
            <LineSeperator />
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <>
                <div className="row topMarginNormal bottomMarginNormal">
                    <div className={"col-lg-4" + (generalError() ? " has-error" : "")}>
                        <Button
                            showSpinner={!applicationSaveError && 
                                (props.supportingDocuments.applicationSavingRequestStatus 
                                === REQUEST_STATUS.IN_PROGRESS)} 
                            id="supporting-doc-save-next-button"
                            text={"Save and next"}
                            buttonType={"regular_primary"}
                            onClick={onNextClick}
                        />
                        {generalError() && ErrorMark()}
                        {generalError() && <div className="ns-error-message help-block topMarginNormal">
                            {generalErrorString()}
                        </div>}
                    </div>
                    {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="col-lg-4">
                        <NavigationLinkButton 
                            id={"supporting-docs-edit-mode-switch"}
                            text={"Update this information before continuing"}
                            onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                        />
                    </div>}
                </div>
            </>
            }
            {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <>
                <div className="topMarginNormal bottomMarginNormal">
                    <div className={generalError() ? " has-error" : ""}>
                        <Button
                            id="supporting-doc-save-button"
                            buttonType={"regular_primary"}
                            text="Save"
                            onClick={() => {
                                if(!validateData()) { 
                                    setShowValidationError(true)
                                    return
                                }

                                setShowValidationError(false)

                                // save and push to next
                                props.dispatch(setAgencySupportingDocuments(
                                    [...formsFiles, ...noticesFiles, ...suretyBondDocs]
                                ))

                                props.onEditSave()
                            }}
                        />
                        {generalError() && ErrorMark()}
                        {generalError() && <div className="help-block">
                            {generalErrorString()}
                        </div>}
                    </div>
                </div>
            </>
            }
        </div>
        </>
    )
}

export default connect(supportingDocumentsSelect)(SupportingDocuments)
